import chalk from "chalk";
export const log = {
  info: (msg: string) => console.log(chalk.blue(msg)),
  success: (msg: string) => console.log(chalk.green(msg)),
  warning: (msg: string) => console.log(chalk.yellow(msg)),
  error: (msg: string) => console.log(chalk.red(msg)),
  title: (msg: string) => console.log(chalk.bold.cyan(msg)),
  code: (msg: string) => console.log(chalk.bgBlack.white(msg)),
};
